<template>
  <div>
    <div class="page">
      <via-nav-bar
        title="填写代码"
        @click-left="$router.$back()"
      >
        <div
          slot="right"
          class="nav-right"
          @click="confirm"
        >保存</div>
      </via-nav-bar>
      <van-cell-group class="field-box">
        <van-field
          ref="input"
          v-model="code"
          class="field"
          placeholder="请输入代码"
          type="textarea"
          :autosize="{maxHeight: inputHeight}"
          :maxlength="65534"
          auto
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Field, CellGroup, Cell } from 'vant'
import { Base64 } from 'js-base64'

export default {
  name: 'InputCode',
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  data() {
    return {
      code: ''
    }
  },
  computed: {
    // px
    inputHeight() {
      const navHeight = 46
      const cellPadding = 20
      return this.$clientHeight - this.$rpxToPx(navHeight + cellPadding)
    }
  },
  activated() {
    this.initData()
    const input = this.$refs['input']
    input.focus()
  },
  methods: {
    initData() {
      const data = this.$store.getters['inputCode/data']
      const key = this.$route.params.storeKey || 'default'
      if (data[key]) {
        const code = data[key]
        this.code = Base64.decode(code) || ''
      }
    },
    confirm() {
      if (!this.code) {
        this.$toast.fail('请先输入代码')
        return
      }
      const key = this.$route.params.storeKey || 'default'
      console.log(JSON.stringify(this.code))
      const code = Base64.encode(this.code)
      this.$store.commit('inputCode/updateData', { ...this.$store.getters['inputCode/data'], [key]: code })
      this.$router.$back()
    }
  }
}
</script>

<style scoped>
.page {
  width: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nav-right {
  color: var(--themeColor)
}
.field-box {
  width: 375px;
}
</style>
